// Dependecies
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useVerifyEmail(token) {
  const [t] = useTranslation('login', { useSuspense: false });
  const [messegeVerify, setVerifyEmail] = useState(false);
  const [messageErrorVerify, setMessageError] = useState(false);

  useEffect(() => {
    const getVerifyEmail = async () => {
      if (token) {
        const response = await fetch(
          `/api/bread/verify_users/search?conditions=[["token","${token}"]]`
        );
        const newVerifyEmail = await response.json();
        if (response.status === 200) {
          if (newVerifyEmail.results.length !== 0) {
            setVerifyEmail(true);
            setMessageError('');
          } else {
            setMessageError(`${t('error-verify')}`);
          }
        }
      }
    };
    getVerifyEmail();
  }, []);

  return {
    messageErrorVerify,
    messegeVerify,
  };
}

export default useVerifyEmail;
